<template>
     <div style="padding-top: 5px">
        <div class="img_box" @click="isActive = !isActive">
          <img :src="img.viewUrl" alt="" srcset="" style="width: 100%; height: auto;">
          <div class="del_box" :class="{ on: isActive }">
            <div class="btn_box" @click.prevent="delteImg(img.atchFileId, img.fileSn)">
              <img src="/images/basic/icon/icon-del-photo.svg" alt="">
              <p>삭제</p>
            </div>
          </div>
        </div>
      </div>  
</template>

<script>
import { deleteFile } from '@/api/boards'
export default {
  props: {
    img: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isActive: false,
    }
  },
  methods: {
    delteImg(atchFileId, fileSn) {
      if(confirm('해당 이미지를 삭제하시겠습니까?')) {
        deleteFile({
            atchFileId,
            fileSn,
            boardId: this.$route.query.boardId,
            nttId: this.$route.query.nttId
          })
          .then(() => {
            this.$emit('deleteImg', this.img.fileSn)
          })
          .catch((error) => {
            console.log(error);
         })
      }
    }
  },
}
</script>

<style scoped>
.img_box {position:relative;}
.img_box .del_box.on {display:block;}
.img_box .del_box {display:none;position:absolute; width:100%; height:100%; background-color:rgba(0,0,0,0.8); top:0; left:0;}
.img_box .del_box .btn_box {position:absolute; top:calc(50% - 23px); left:calc(50% - 13px); text-align: center;}
.img_box .del_box .btn_box img {max-width:26px;}
.img_box .del_box .btn_box p {color:#fff; font-size:14px;}
</style>